import React, { useEffect } from "react";
import { toast } from "sonner";

// Turns a durable-storage failure into a clear, safe, user-facing NOT-SAVED message.
// Never exposes SQL, stack traces, paths, tokens or internal plugin messages.
export default function OfflineErrorToaster() {
  useEffect(() => {
    const onErr = (e) => {
      const ref = e?.detail?.reference || "—";
      toast.error("Not saved — offline storage unavailable", {
        description: `This device can't save records offline right now, so this record has not been saved. Reconnect and try again. Reference: ${ref}`,
        duration: 10000,
      });
    };
    window.addEventListener("cc:offline-storage-error", onErr);
    return () => window.removeEventListener("cc:offline-storage-error", onErr);
  }, []);
  return <div data-testid="offline-error-toaster" style={{ display: "none" }} />;
}
